import React from "react";
import Header from './../Common/Header';
import Footer from './../Common/Footer';
import Banner from './../Elements/Banner';

var bnrimg = require('./../../images/banner/4.jpg');

const focusData = [
  {
    icon: "bi-buildings",
    title: "Infrastructure Excellence",
    text: "We deliver large-scale infrastructure projects with precision, disciplined planning, world-class engineering standards, and timely execution ensuring durability, reliability, and long-term performance."
  },
  {
    icon: "bi-house-heart",
    title: "Real Estate Development",
    text: "We develop premium villas, plotted layouts, integrated townships and lifestyle communities across key growth corridors, designed for comfort, connectivity, appreciation value, and superior living."
  },
  {
    icon: "bi-lightbulb",
    title: "Innovation & Technology",
    text: "We adopt advanced engineering, modern technology, future-ready planning models and smart execution systems to create efficient, intelligent and high-performing developments."
  },
  {
    icon: "bi-tree",
    title: "Sustainability",
    text: "We create eco-friendly environments with responsible land use, abundant green spaces, landscaped surroundings, and community planning focused on long-term environmental care."
  },
  {
    icon: "bi-shield-check",
    title: "Strong Governance",
    text: "Every project follows disciplined procedures, transparent processes, legal clarity, structured execution frameworks, expert advisory support, and compliance excellence."
  },
  {
    icon: "bi-people-heart",
    title: "Customer Trust",
    text: "Customer trust is our foundation. We build long-term relationships by delivering what we promise — integrity, secure investments, quality commitment and reliable execution."
  },
  {
    icon: "bi-gear-wide-connected",
    title: "Own Machinery Advantage",
    text: "With fully owned high-capacity machinery and in-house execution capability, we ensure faster project delivery, strict quality control, efficiency, and strong operational strength."
  }
];

class Focus extends React.Component {
  componentDidMount() {
    try {
      const AOS = require('aos');
      if (AOS && AOS.init) AOS.init({ duration: 1200, once: true });
    } catch (e) {
      // AOS not available — skip initialization
    }
  }

  render() {
    return (
      <>
        <Header />
        <Banner title="Our Focus" pagename="Focus Areas" bgimage={bnrimg} />

        <div className="container py-5">
          <div className="text-center mb-5">
            <h2 className="fw-bold text-primary" data-aos="fade-down">
              Our Focus Areas
            </h2>
            <p className="text-muted fs-5" data-aos="fade-up">
              Driving growth through strategy, innovation, governance and excellence.
            </p>
          </div>

          <div className="row g-4">
            {focusData.map((item, index) => (
              <div className="col-lg-4 col-md-6" key={index}>
                <div className="shadow-lg p-4 rounded-4 text-center h-100 border-0 bg-white" data-aos="zoom-in">
                  <div className="mb-3">
                    <i className={`bi ${item.icon} text-primary`} style={{ fontSize: '45px' }} />
                  </div>
                  <h5 className="fw-bold">{item.title}</h5>
                  <p className="text-muted">{item.text}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <Footer />
      </>
    );
  }
}

export default Focus;